import(/* webpackMode: "eager" */ "/app/apps/affiliates/src/app/global-error.tsx");
